module.exports = {
  "fo-0010": {
    "identifierType": "PORTAL_ID",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  }
};